import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import CardRegister from '../CardRegister';
import axios from 'axios';
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import translationEN from "../../constants/locales/en/translation.json";
import translationID from "../../constants/locales/id/translation.json";


const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lang') || 'en',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});


function RegisterForm() {
  const [isRegistered, setIsRegistered] = useState(false);
  const [emailExistsError, setEmailExistsError] = useState('');
  const { t } = useTranslation();
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const password = watch("password");

  const onSubmit = async (data) => {
    try {
      const { confirmPassword, ...postData } = data;
  
      const response = await axios.post('https://backend2.senarai-app.com/register', postData);
      console.log(response.data); 
      setIsRegistered(true);
    } catch (error) {
      if (error.response?.request.status === 400) {
        setEmailExistsError(t("register_400"));
      }
    }
  };

  return (
    <div style={{ maxHeight: '600px' }} className="w-full max-w-md ml-[3cm] mt-[2cm] p-[1.7cm] bg-white border border-gray-200 rounded-3xl shadow-2xl shadow-slate-300">
      <div className="flex items-center">
        <p className="font-lato font-bold text-[24px]">{t("signup_title")}</p>
        <p className="text-[14px] text-black font-lato text-justify ml-[2cm]">{t("signup_have_acc")}
          <a href="/" className=" font-lato text-[#2D3494] underline">{t("login_here")}</a>
        </p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='mt-3 font-lato'>
          <label htmlFor="name">{t("signup_name")}</label>
          <input
            id="name"
            className="w-full border border-gray-300 rounded-lg p-2"
            type="name"
            name="name"
            {...register("name",  {
              required: t("register_empty_name"),
              pattern: {
                value: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
                message: t("register_invalid_name"),
              },
            })}
          />
          {errors.name && <h4 className="text-[13px] text-[#E91D25]">{errors.name.message}</h4>}
        </div>
        <div className='mt-3 font-lato'>
          <label htmlFor="email">{t("signup_email")}</label>
          <input
            id="email"
            className="w-full border border-gray-300 rounded-lg p-2"
            type="text"
            name="email"
            {...register("email", {
              required: t("register_empty_email"),
              pattern: {
                value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                message: t("register_invalid_email"),
              },
            })}
          />
          {errors.email && <h4 className="text-[13px] text-[#E91D25]">{errors.email.message}</h4>}
          {emailExistsError && <h4 className="text-[13px] text-[#E91D25]">{emailExistsError}</h4>}
        </div>
        <div className='mt-3 font-lato'>
          <label htmlFor="password">{t("signup_password")}</label>
          <input
            id="password"
            className="w-full border border-gray-300 rounded-lg p-2"
            type="password"
            name="password"
            {...register("password", {
              required: t("register_empty_password"),
              minLength: {
                value: 8,
                message: t("register_password_too_short"),
              },
            })}
          />
          {errors.password && <h4 className="text-[13px] text-[#E91D25]">{errors.password.message}</h4>}
          <h4 className="text-[13px] font-lato text-[#475467]">{t("signup_password_description")}</h4>
        </div>
        <div className='mt-3 font-lato'>
          <label htmlFor="confirmPassword">{t("signup_confirm_password")}</label>
          <input
            id="confirmPassword"
            className="w-full border border-gray-300 rounded-lg p-2"
            type="password"
            name="confirmPassword"
            {...register("confirmPassword", {
              required: t("register_empty_confirm_password"),
              validate: (value) => value === password || t("register_password_dont_match"),
            })}
          />
          {errors.confirmPassword && <h4 className="text-[13px] text-[#E91D25]">{errors.confirmPassword.message}</h4>}
        </div>
        <div className='flex justify-center mt-[1.2cm] font-lato'>
          <button
            type="submit"
            className="flex items-center bg-[#2D3494] hover:bg-white hover:text-[#2D3494] hover:border border-[#2D3494] text-white font-lato py-2 px-4 rounded-lg"
          >
            {t("signup_create_acc")}
          </button>
        </div>
      </form>
      {isRegistered && (
        <div className="fixed top-0 left-0 flex justify-center items-center w-full h-full bg-gray-700 bg-opacity-50">
          <CardRegister />
        </div>
      )}
    </div>
  );
}

export default RegisterForm;
